export default {
  moneyReport: {
    results: [],
  },
}
